module.exports = {
  platform: 'chat',
  name: 'output',
  node: 'chat_output',
  bg: '#FFFFFF',
  note: '',
  property: {
    bot_says: []
  }
}
